jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });


  
});


// if ( (window.location.pathname === '/' || window.location.pathname === '/index.html') ) {
//   $(document).ready(function(){
//       // Show the popup when the page is loaded
//       $('.advance-modal').fadeIn();
  
//       // Close the popup when the close button is clicked
//       $('.close').click(function(){
//           $('.advance-modal').fadeOut();
//       });
//   });
// }
